'use client';
import Button from 'src/components/Button';
import useViewModeState from './useViewModeState';
import Monitor from '../../../../../public/images/monitor.svg';
import Iphone from '../../../../../public/images/iphone.svg';

const buttonType = (active: boolean) => (active ? 'primary' : 'default');

export default function ToggleViewMode({ label }: { label: string }) {
    const { viewMode, setViewMode } = useViewModeState();

    return (
        <div className="flex flex-row flex-wrap items-center gap-4">
            {!!label && <div className="w-full grow text-center sm:w-auto sm:flex-none">{label}</div>}
            <Button
                variant={buttonType(viewMode === 'desktop')}
                onClick={() => setViewMode('desktop')}
                className="flex-1 sm:flex-initial">
                <Monitor className="mr-3 inline" />
                Desktop
            </Button>

            <Button
                variant={buttonType(viewMode === 'mobile')}
                onClick={() => setViewMode('mobile')}
                className="flex-1 sm:flex-initial">
                <Iphone className="mr-3 inline" />
                Mobil
            </Button>
        </div>
    );
}
